module.exports = __webpack_public_path__ + "img/CompletedNotificationclose.336ed0b8.svg";